export { useLegalDocuments } from './hooks/useLegalDocuments';
export { groupLegalDocuments, type LegalDocumentGroup } from './utils/groupLegalDocuments';
export {
  deriveSignedDocuments,
  isLegalKeyAgreed,
  type AgreementsRecord,
} from './utils/deriveSignedDocuments';
